// 2015 Topps Star Wars Chrome Perspectives: Jedi vs. Sith — authored by hand
// (2026-09-18, collector-requested)
// =============================================================================
// SOURCES: no official Topps PDF was available, so this file is a three-way
// cross-check of nslists.com (House of Checklists, collector-maintained),
// Cardboard Connection's release checklist, and TCDB (sid 114595 + each
// insert's own sid). Names were taken from whichever pair of sources agreed;
// every disagreement is documented below.
//
// BASE: 100 cards in two 50-card halves — Jedi Temple Archives (1-J..50-J)
// and Sith Information Guide (1-S..50-S). The same 50 subjects appear in both
// halves with mirrored flavor text, and both halves share one parallel ladder,
// so they live in a single sub-set keyed by the printed -J/-S numbers.
// Cardboard Connection's base list is partly corrupted ("Obi Kenobi",
// "Yoda Yoda"); names follow nslists, spot-checked against TCDB (which agrees:
// 3-J Obi-Wan Kenobi, 4-J Yoda).
//
// INSERTS: five 10-card sets. Their only parallels are printing plates, which
// CK does not track (same convention as every other set file). Disputes all
// resolved 2-to-1: Jedi Information Guide DOES have a #3 "Peace" (TCDB + CC;
// nslists alone says "no #3"), Sith Propaganda #10 is "Then You Are My Enemy"
// (TCDB + CC over nslists' "Then You Are the Enemy!"). Insert odds per TCDB +
// nslists: Fugitives 1:2, Hunt 1:4, Propaganda 1:8, Information Guide 1:12,
// Training 1:24.
//
// AUTOGRAPHS: 22 on-card signers. The unnumbered base autograph exists for 21
// of them — Mark Hamill is found ONLY in serial-numbered versions (all three
// sources agree), and per-signer parallel coverage varies (nslists documents
// which signer has which tiers). CK's uniform ladder can't express per-card
// gaps, so the ladder below is the full program and the gaps live in this
// note. nslists alone lists an unnumbered "Green" parallel; TCDB and CC don't
// — omitted (single-source). TCDB spells one signer "Zac Jensen"; nslists and
// CC both print "Zach Jensen", kept here.
//
// DUAL / TRIPLE AUTOGRAPHS: sticker autos, all serial-numbered bases, so each
// sub-set carries the blank-name serial slot (rule 6). Six duals at /200
// (several also exist as redemptions at the same run), three "ultra rare"
// duals at /3 with different pairings (their own sub-set — they are different
// cards, not parallels), and two triples at /5. Ian McDiarmid's cards were
// redemptions not live at release (nslists).
//
// MEDALLIONS: 36 unnumbered cards (NNO on TCDB) — 12 duels x 3 designs
// (matchup / duel / winner), one medallion coin per duel reused across its
// three designs. CK-internal M-1..M-36 in the film-chronological order TCDB
// and Cardboard Connection share. The printed cards repeat names across
// trios, so the parenthetical location/opponent tags are CK-added
// disambiguation (locations from nslists, winners from CC — all
// film-accurate). Base is Bronze, LIMITED to 299 but NOT serial-numbered
// (TCDB "PR299"; eBay specimens show serials on Silver/Gold only), so no
// rule-6 slot; Silver /150 and Gold /50 are numbered.
//
// THE FORCE AWAKENS PREVIEW: 8 glossy cards pulled 1:24 packs, keeping their
// card numbers from the upcoming TFA Series 1 checklist (11, 53, 67, 74, 76,
// 81, 88, 96); the Matte Finish parallel fell ~1 per case. TCDB catalogs
// these under "promo sets", but they were pack-inserted, so they're tracked.
// The five P1-P5 promos (conventions / Star Wars Insider) were NOT
// pack-inserted and are left out.
//
// SKETCHES: 106 artists, chromium-border sketch cards, from the nslists
// roster (the most complete). TCDB's roster is 105 and differs on three rows:
// it omits Nigel Sade, and prints "Albert Lambert" / "Chris Ehnot" where
// nslists has "Aaron Lambert" / "Chris Elliott" — an eBay specimen (Count
// Dooku sketch "by Chris Elliott") and CC's artist list back nslists on both.
// Sketch redemption cards existed at release (nslists) and resolve to these
// artists.
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE — JEDI TEMPLE ARCHIVES (-J) / SITH INFORMATION GUIDE (-S)",
    parallels: [
        { id: "refractor", name: "Refractor", print_run: null, color: "#c8d8f0" },
        { id: "prism-refractor", name: "Prism Refractor", print_run: 199, color: "#b388ff" },
        { id: "xfractor", name: "X-Fractor", print_run: 99, color: "#76ff03" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "1-J", name: "Luke Skywalker" },
        { n: "2-J", name: "Anakin Skywalker" },
        { n: "3-J", name: "Obi-Wan Kenobi" },
        { n: "4-J", name: "Yoda" },
        { n: "5-J", name: "Mace Windu" },
        { n: "6-J", name: "Shaak Ti" },
        { n: "7-J", name: "Aayla Secura" },
        { n: "8-J", name: "Plo Koon" },
        { n: "9-J", name: "Saesee Tiin" },
        { n: "10-J", name: "Qui-Gon Jinn" },
        { n: "11-J", name: "Kit Fisto" },
        { n: "12-J", name: "Barriss Offee" },
        { n: "13-J", name: "Ahsoka Tano" },
        { n: "14-J", name: "Ki-Adi-Mundi" },
        { n: "15-J", name: "Quinlan Vos" },
        { n: "16-J", name: "Luminara Unduli" },
        { n: "17-J", name: "Even Piell" },
        { n: "18-J", name: "Padmé Amidala" },
        { n: "19-J", name: "Han Solo" },
        { n: "20-J", name: "Princess Leia Organa" },
        { n: "21-J", name: "Sheev Palpatine" },
        { n: "22-J", name: "Jar Jar Binks" },
        { n: "23-J", name: "Clone Troopers" },
        { n: "24-J", name: "Chewbacca" },
        { n: "25-J", name: "Jocasta Nu" },
        { n: "26-J", name: "Darth Sidious" },
        { n: "27-J", name: "Darth Vader" },
        { n: "28-J", name: "Darth Maul" },
        { n: "29-J", name: "Count Dooku" },
        { n: "30-J", name: "Asajj Ventress" },
        { n: "31-J", name: "The Inquisitor" },
        { n: "32-J", name: "Darth Bane" },
        { n: "33-J", name: "Jango Fett" },
        { n: "34-J", name: "Boba Fett" },
        { n: "35-J", name: "Jabba The Hutt" },
        { n: "36-J", name: "The Trade Federation" },
        { n: "37-J", name: "General Grievous" },
        { n: "38-J", name: "Stormtroopers" },
        { n: "39-J", name: "Aurra Sing" },
        { n: "40-J", name: "Savage Opress" },
        { n: "41-J", name: "Mas Amedda" },
        { n: "42-J", name: "Tarkin" },
        { n: "43-J", name: "Pre Vizsla" },
        { n: "44-J", name: "Sly Moore" },
        { n: "45-J", name: "Lama Su" },
        { n: "46-J", name: "Poggle The Lesser" },
        { n: "47-J", name: "Bossk" },
        { n: "48-J", name: "Hondo Ohnaka" },
        { n: "49-J", name: "Mother Talzin" },
        { n: "50-J", name: "Zam Wesell" },
        { n: "1-S", name: "Luke Skywalker" },
        { n: "2-S", name: "Anakin Skywalker" },
        { n: "3-S", name: "Obi-Wan Kenobi" },
        { n: "4-S", name: "Yoda" },
        { n: "5-S", name: "Mace Windu" },
        { n: "6-S", name: "Shaak Ti" },
        { n: "7-S", name: "Aayla Secura" },
        { n: "8-S", name: "Plo Koon" },
        { n: "9-S", name: "Saesee Tiin" },
        { n: "10-S", name: "Qui-Gon Jinn" },
        { n: "11-S", name: "Kit Fisto" },
        { n: "12-S", name: "Barriss Offee" },
        { n: "13-S", name: "Ahsoka Tano" },
        { n: "14-S", name: "Ki-Adi-Mundi" },
        { n: "15-S", name: "Quinlan Vos" },
        { n: "16-S", name: "Luminara Unduli" },
        { n: "17-S", name: "Even Piell" },
        { n: "18-S", name: "Padmé Amidala" },
        { n: "19-S", name: "Han Solo" },
        { n: "20-S", name: "Princess Leia Organa" },
        { n: "21-S", name: "Sheev Palpatine" },
        { n: "22-S", name: "Jar Jar Binks" },
        { n: "23-S", name: "Clone Troopers" },
        { n: "24-S", name: "Chewbacca" },
        { n: "25-S", name: "Jocasta Nu" },
        { n: "26-S", name: "Darth Sidious" },
        { n: "27-S", name: "Darth Vader" },
        { n: "28-S", name: "Darth Maul" },
        { n: "29-S", name: "Count Dooku" },
        { n: "30-S", name: "Asajj Ventress" },
        { n: "31-S", name: "The Inquisitor" },
        { n: "32-S", name: "Darth Bane" },
        { n: "33-S", name: "Jango Fett" },
        { n: "34-S", name: "Boba Fett" },
        { n: "35-S", name: "Jabba The Hutt" },
        { n: "36-S", name: "The Trade Federation" },
        { n: "37-S", name: "General Grievous" },
        { n: "38-S", name: "Stormtroopers" },
        { n: "39-S", name: "Aurra Sing" },
        { n: "40-S", name: "Savage Opress" },
        { n: "41-S", name: "Mas Amedda" },
        { n: "42-S", name: "Tarkin" },
        { n: "43-S", name: "Pre Vizsla" },
        { n: "44-S", name: "Sly Moore" },
        { n: "45-S", name: "Lama Su" },
        { n: "46-S", name: "Poggle The Lesser" },
        { n: "47-S", name: "Bossk" },
        { n: "48-S", name: "Hondo Ohnaka" },
        { n: "49-S", name: "Mother Talzin" },
        { n: "50-S", name: "Zam Wesell" },
    ],
  },
  {
    id: "sith-fugitives",
    type: "insert",
    title: "THREAT TO THE REPUBLIC: SITH FUGITIVES",
    parallels: [],
    cards: [
        { n: "1", name: "Darth Sidious" },
        { n: "2", name: "Darth Maul" },
        { n: "3", name: "Darth Tyranus" },
        { n: "4", name: "General Grievous" },
        { n: "5", name: "Darth Vader" },
        { n: "6", name: "Asajj Ventress" },
        { n: "7", name: "Savage Oppress" },
        { n: "8", name: "Mother Talzin" },
        { n: "9", name: "The Inquisitor" },
        { n: "10", name: "Aurra Sing" },
    ],
  },
  {
    id: "jedi-hunt",
    type: "insert",
    title: "WANTED: JEDI HUNT",
    parallels: [],
    cards: [
        { n: "1", name: "Yoda" },
        { n: "2", name: "Obi-Wan Kenobi" },
        { n: "3", name: "Mace Windu" },
        { n: "4", name: "Qui-Gon Jinn" },
        { n: "5", name: "Aayla Secura" },
        { n: "6", name: "Kit Fisto" },
        { n: "7", name: "Shaak Ti" },
        { n: "8", name: "Ahsoka Tano" },
        { n: "9", name: "Anakin Skywalker" },
        { n: "10", name: "Luke Skywalker" },
    ],
  },
  {
    id: "sith-propaganda",
    type: "insert",
    title: "SITH PROPAGANDA",
    parallels: [],
    cards: [
        { n: "1", name: "Vengeance" },
        { n: "2", name: "Submit" },
        { n: "3", name: "Master" },
        { n: "4", name: "Conquest" },
        { n: "5", name: "Fear Is My Ally" },
        { n: "6", name: "The Rule of Two" },
        { n: "7", name: "Traitor" },
        { n: "8", name: "It Is Your Destiny" },
        { n: "9", name: "Loyalty" },
        { n: "10", name: "Then You Are My Enemy" },
    ],
  },
  {
    id: "jedi-information-guide",
    type: "insert",
    title: "JEDI INFORMATION GUIDE",
    parallels: [],
    cards: [
        { n: "1", name: "The Force" },
        { n: "2", name: "Redemption" },
        { n: "3", name: "Peace" },
        { n: "4", name: "Be Mindful" },
        { n: "5", name: "The Jedi Order" },
        { n: "6", name: "The Republic Needs Your Younglings" },
        { n: "7", name: "Forever Will It Dominate Your Destiny" },
        { n: "8", name: "My Ally Is The Force" },
        { n: "9", name: "A Jedi" },
        { n: "10", name: "Vigilance" },
    ],
  },
  {
    id: "jedi-training",
    type: "insert",
    title: "JEDI TRAINING",
    parallels: [],
    cards: [
        { n: "1", name: "Patience" },
        { n: "2", name: "Control" },
        { n: "3", name: "Levitation" },
        { n: "4", name: "Force Push" },
        { n: "5", name: "Jedi Mind Trick" },
        { n: "6", name: "Force Leap" },
        { n: "7", name: "Jedi Speed" },
        { n: "8", name: "Leadership" },
        { n: "9", name: "Lightsaber Combat" },
        { n: "10", name: "Piloting" },
    ],
  },
  {
    id: "autograph-cards",
    type: "auto",
    title: "AUTOGRAPHS",
    parallels: [
        { id: "prism-refractor", name: "Prism Refractor", print_run: 50, color: "#b388ff" },
        { id: "xfractor", name: "X-Fractor", print_run: 25, color: "#76ff03" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 10, color: "#f0c040" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "A-1", name: "Amy Allen as Aayla Secura" },
        { n: "A-2", name: "Ashley Eckstein as Ahsoka Tano" },
        { n: "A-3", name: "Barbara Goodson as Mother Talzin" },
        { n: "A-4", name: "Carrie Fisher as Princess Leia" },
        { n: "A-5", name: "David Prowse as Darth Vader" },
        { n: "A-6", name: "Jennifer Hale as Aayla Secura" },
        { n: "A-7", name: "Jerome Blake as Oppo Rancisis" },
        { n: "A-8", name: "Mark Hamill as Luke Skywalker" },
        { n: "A-9", name: "Matthew Wood as General Grievous" },
        { n: "A-10", name: "Michaela Cottrell as Even Piell" },
        { n: "A-11", name: "Nalini Krishan as Barriss Offee" },
        { n: "A-12", name: "Nick Gillard as Cin Drallig" },
        { n: "A-13", name: "Nika Futterman as Asajj Ventress" },
        { n: "A-14", name: "Olivia D'Abo as Luminara Unduli" },
        { n: "A-15", name: "Orli Shoshan as Shaak Ti" },
        { n: "A-16", name: "Peter Mayhew as Chewbacca" },
        { n: "A-17", name: "Phil Eason as Yaddle" },
        { n: "A-18", name: "Ray Park as Darth Maul" },
        { n: "A-19", name: "Sam Witwer as Darth Maul" },
        { n: "A-20", name: "Silas Carson as Ki-Adi-Mundi" },
        { n: "A-21", name: "Taylor Gray as Ezra Bridger" },
        { n: "A-22", name: "Zach Jensen as Kit Fisto" },
    ],
  },
  {
    id: "dual-autographs",
    type: "auto",
    title: "DUAL AUTOGRAPHS",
    parallels: [
        { id: "numbered", name: "", print_run: 200, color: "#c8d8f0" },
      ],
    cards: [
        { n: "DA-1", name: "Ashley Eckstein / Olivia D'Abo", artist: "Ahsoka Tano / Luminara Unduli" },
        { n: "DA-2", name: "Nina Fallon / Nalini Krishan", artist: "Stass Allie / Barriss Offee" },
        { n: "DA-3", name: "Nika Futterman / Barbara Goodson", artist: "Asajj Ventress / Mother Talzin" },
        { n: "DA-4", name: "Amy Allen / Orli Shoshan", artist: "Aayla Secura / Shaak Ti" },
        { n: "DA-5", name: "Michaela Cottrell / Zach Jensen", artist: "Even Piell / Kit Fisto" },
        { n: "DA-6", name: "Ashley Eckstein / Nika Futterman", artist: "Ahsoka Tano / Asajj Ventress" },
    ],
  },
  {
    id: "dual-autographs-ultra-rare",
    type: "auto",
    title: "DUAL AUTOGRAPHS — ULTRA RARE",
    parallels: [
        { id: "numbered", name: "", print_run: 3, color: "#c8d8f0" },
      ],
    cards: [
        { n: "DU-1", name: "Mark Hamill / Carrie Fisher", artist: "Luke Skywalker / Princess Leia" },
        { n: "DU-2", name: "Ian McDiarmid / David Prowse", artist: "Emperor Palpatine / Darth Vader" },
        { n: "DU-3", name: "Ian McDiarmid / Ray Park", artist: "Emperor Palpatine / Darth Maul" },
    ],
  },
  {
    id: "triple-autographs",
    type: "auto",
    title: "TRIPLE AUTOGRAPHS",
    parallels: [
        { id: "numbered", name: "", print_run: 5, color: "#c8d8f0" },
      ],
    cards: [
        { n: "TA-1", name: "Mark Hamill / David Prowse / Ian McDiarmid", artist: "Luke Skywalker / Darth Vader / Emperor Palpatine" },
        { n: "TA-2", name: "Ian McDiarmid / David Prowse / Ray Park", artist: "Emperor Palpatine / Darth Vader / Darth Maul" },
    ],
  },
  {
    id: "medallion-cards",
    type: "insert",
    title: "MEDALLION CARDS",
    parallels: [
        { id: "silver", name: "Silver", print_run: 150, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 50, color: "#f0c040" },
      ],
    cards: [
        { n: "M-1", name: "Qui-Gon Jinn vs. Darth Maul (Tatooine)" },
        { n: "M-2", name: "Duel on Tatooine: Qui-Gon Jinn vs. Darth Maul" },
        { n: "M-3", name: "Winner: Darth Maul (vs. Qui-Gon Jinn)" },
        { n: "M-4", name: "Obi-Wan Kenobi vs. Darth Maul (Naboo)" },
        { n: "M-5", name: "Duel on Naboo: Obi-Wan Kenobi vs. Darth Maul" },
        { n: "M-6", name: "Winner: Obi-Wan Kenobi (vs. Darth Maul)" },
        { n: "M-7", name: "Obi-Wan Kenobi vs. Count Dooku (Geonosis)" },
        { n: "M-8", name: "Duel on Geonosis: Obi-Wan Kenobi vs. Count Dooku" },
        { n: "M-9", name: "Winner: Count Dooku (vs. Obi-Wan Kenobi)" },
        { n: "M-10", name: "Yoda vs. Count Dooku (Geonosis)" },
        { n: "M-11", name: "Duel on Geonosis: Yoda vs. Count Dooku" },
        { n: "M-12", name: "Winner: Yoda (vs. Count Dooku)" },
        { n: "M-13", name: "Anakin Skywalker vs. Count Dooku (Coruscant)" },
        { n: "M-14", name: "Duel on Coruscant: Anakin Skywalker vs. Count Dooku" },
        { n: "M-15", name: "Winner: Anakin Skywalker (vs. Count Dooku)" },
        { n: "M-16", name: "Obi-Wan Kenobi vs. General Grievous (Utapau)" },
        { n: "M-17", name: "Duel on Utapau: Obi-Wan Kenobi vs. General Grievous" },
        { n: "M-18", name: "Winner: Obi-Wan Kenobi (vs. General Grievous)" },
        { n: "M-19", name: "Mace Windu vs. Darth Sidious (Coruscant)" },
        { n: "M-20", name: "Duel on Coruscant: Mace Windu vs. Darth Sidious" },
        { n: "M-21", name: "Winner: Darth Sidious (vs. Mace Windu)" },
        { n: "M-22", name: "Anakin Skywalker vs. Obi-Wan Kenobi (Mustafar)" },
        { n: "M-23", name: "Duel on Mustafar: Anakin Skywalker vs. Obi-Wan Kenobi" },
        { n: "M-24", name: "Winner: Obi-Wan Kenobi (vs. Anakin Skywalker)" },
        { n: "M-25", name: "Yoda vs. Darth Sidious (Coruscant)" },
        { n: "M-26", name: "Duel on Coruscant: Yoda vs. Darth Sidious" },
        { n: "M-27", name: "Winner: Darth Sidious (vs. Yoda)" },
        { n: "M-28", name: "Darth Vader vs. Obi-Wan Kenobi (The Death Star)" },
        { n: "M-29", name: "Duel on the Death Star: Darth Vader vs. Obi-Wan Kenobi" },
        { n: "M-30", name: "Winner: Darth Vader (vs. Obi-Wan Kenobi)" },
        { n: "M-31", name: "Luke Skywalker vs. Darth Vader (Bespin)" },
        { n: "M-32", name: "Duel on Bespin: Luke Skywalker vs. Darth Vader" },
        { n: "M-33", name: "Winner: Darth Vader (vs. Luke Skywalker)" },
        { n: "M-34", name: "Luke Skywalker vs. Darth Vader (The Second Death Star)" },
        { n: "M-35", name: "Duel on the Second Death Star: Luke Skywalker vs. Darth Vader" },
        { n: "M-36", name: "Winner: Luke Skywalker (vs. Darth Vader)" },
    ],
  },
  {
    id: "force-awakens-preview",
    type: "insert",
    title: "THE FORCE AWAKENS PREVIEW",
    parallels: [
        { id: "matte-finish", name: "Matte Finish", print_run: null, color: "#9aa7c0" },
      ],
    cards: [
        { n: "11", name: "BB-8 on the move!" },
        { n: "53", name: "Poe Dameron in his X-Wing" },
        { n: "67", name: "Kylo Ren ignites his Lightsaber!" },
        { n: "74", name: "Rey on her speeder" },
        { n: "76", name: "Finn on the run!" },
        { n: "81", name: "Stormtroopers prepare for battle!" },
        { n: "88", name: "X-Wings in formation!" },
        { n: "96", name: "The Millennium Falcon" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH ARTISTS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Aaron Lambert" },
        { n: "SK-2", name: "Achilleas Kokkinakis" },
        { n: "SK-3", name: "Adam Talley" },
        { n: "SK-4", name: "Adrien Rivera" },
        { n: "SK-5", name: "Alex \"Ironhed\" Sanchez" },
        { n: "SK-6", name: "Andrew \"Drone\" Cosson" },
        { n: "SK-7", name: "Bill Pulkovski" },
        { n: "SK-8", name: "Brad Hudson" },
        { n: "SK-9", name: "Brad Utterstrom" },
        { n: "SK-10", name: "Brent Ragland" },
        { n: "SK-11", name: "Carla Rodriguez" },
        { n: "SK-12", name: "Carlos Cabaleiro" },
        { n: "SK-13", name: "Chad McCown" },
        { n: "SK-14", name: "Charles Dowd" },
        { n: "SK-15", name: "Charles Hall" },
        { n: "SK-16", name: "Chris Elliott" },
        { n: "SK-17", name: "Chris Henderson" },
        { n: "SK-18", name: "Chris West" },
        { n: "SK-19", name: "Crystal \"Bamboota\" Fontan" },
        { n: "SK-20", name: "Dan Bergren" },
        { n: "SK-21", name: "Dan Nokes" },
        { n: "SK-22", name: "Dan Parsons" },
        { n: "SK-23", name: "Dan \"Smif\" Smith" },
        { n: "SK-24", name: "Daniel Contois" },
        { n: "SK-25", name: "Danny Haas" },
        { n: "SK-26", name: "Darrin Pepe" },
        { n: "SK-27", name: "David \"Valent\" Valentine" },
        { n: "SK-28", name: "Denae Frazier" },
        { n: "SK-29", name: "Eric Kowalick" },
        { n: "SK-30", name: "Eric Lehtonen" },
        { n: "SK-31", name: "Erik Maell" },
        { n: "SK-32", name: "Francois Chartier" },
        { n: "SK-33", name: "Gavin Hunt" },
        { n: "SK-34", name: "Howard Russell" },
        { n: "SK-35", name: "Ingrid Hardy" },
        { n: "SK-36", name: "Irma \"Aimo\" Ahmed" },
        { n: "SK-37", name: "Jamie Cosley" },
        { n: "SK-38", name: "Jared Hickman" },
        { n: "SK-39", name: "Jason Adams" },
        { n: "SK-40", name: "Jason Brower" },
        { n: "SK-41", name: "Jason Chalker" },
        { n: "SK-42", name: "Jason Flowers" },
        { n: "SK-43", name: "Jason Sobol" },
        { n: "SK-44", name: "Jeffrey Benitez" },
        { n: "SK-45", name: "Jessica Hickman" },
        { n: "SK-46", name: "Joe Hogan" },
        { n: "SK-47", name: "John Soukup" },
        { n: "SK-48", name: "Jordan Maison" },
        { n: "SK-49", name: "Josh Bodwell" },
        { n: "SK-50", name: "Josh Lyman" },
        { n: "SK-51", name: "Kaela Croft" },
        { n: "SK-52", name: "Karen Hinson" },
        { n: "SK-53", name: "Kate Carleton" },
        { n: "SK-54", name: "Ken Knudtsen" },
        { n: "SK-55", name: "Kevin Graham" },
        { n: "SK-56", name: "Kevin West" },
        { n: "SK-57", name: "Kimberly Dunaway" },
        { n: "SK-58", name: "Kris Penix" },
        { n: "SK-59", name: "Kyle Babbitt" },
        { n: "SK-60", name: "Lak Lim" },
        { n: "SK-61", name: "Laura Guzzo" },
        { n: "SK-62", name: "Lee Lightfoot" },
        { n: "SK-63", name: "Lord Mesa" },
        { n: "SK-64", name: "Marcia Dye" },
        { n: "SK-65", name: "Marck Labas" },
        { n: "SK-66", name: "Mark Hammermeister" },
        { n: "SK-67", name: "Mark Picirilli" },
        { n: "SK-68", name: "Matt Stewart" },
        { n: "SK-69", name: "Matthew Sutton" },
        { n: "SK-70", name: "Melike Acar" },
        { n: "SK-71", name: "Michael \"Locoduck\" Duron" },
        { n: "SK-72", name: "Michael Leavitt" },
        { n: "SK-73", name: "Mick + Matt Glebe" },
        { n: "SK-74", name: "Nigel Sade" },
        { n: "SK-75", name: "Norvien Basio" },
        { n: "SK-76", name: "Omar Maya Velazquez" },
        { n: "SK-77", name: "Pablo Diaz" },
        { n: "SK-78", name: "Patricia Ross" },
        { n: "SK-79", name: "Patrick Giles" },
        { n: "SK-80", name: "Paul \"Gutz\" Guttierez" },
        { n: "SK-81", name: "Peter \"Zuno\" Chan" },
        { n: "SK-82", name: "Rich Kunz" },
        { n: "SK-83", name: "Rich Molinelli" },
        { n: "SK-84", name: "Robert Hendrickson" },
        { n: "SK-85", name: "Robert Teranishi" },
        { n: "SK-86", name: "RoCom" },
        { n: "SK-87", name: "Roy Cover" },
        { n: "SK-88", name: "Ryan van der Draaij" },
        { n: "SK-89", name: "Sarah Wilkinson" },
        { n: "SK-90", name: "Scott Houseman" },
        { n: "SK-91", name: "Scott Zambelli" },
        { n: "SK-92", name: "Sean Pence" },
        { n: "SK-93", name: "Sol Mohamed" },
        { n: "SK-94", name: "Stephanie Swanger" },
        { n: "SK-95", name: "Steven Burch" },
        { n: "SK-96", name: "Sue Thomas" },
        { n: "SK-97", name: "Tanner Padlo" },
        { n: "SK-98", name: "Ted Dastick Jr." },
        { n: "SK-99", name: "Tim Dowler" },
        { n: "SK-100", name: "Tim Shay" },
        { n: "SK-101", name: "Tina Berardi" },
        { n: "SK-102", name: "Tom Carlton" },
        { n: "SK-103", name: "Tomoko Taniguchi" },
        { n: "SK-104", name: "Tressina Bowling" },
        { n: "SK-105", name: "Ward Silverman" },
        { n: "SK-106", name: "Wilson Ramos Jr." },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array (or deliberately none), so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
